import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Header, Item } from 'semantic-ui-react';
import { format, parseISO } from 'date-fns';
import { Link } from 'gatsby';
import Image from '../../../../atoms/Image';
import { GatsbyImagePropType } from '../../../../services/proptypes';
import ObjectUtils from '../../../../utils/ObjectUtils';
import './FeaturedBlogPost.css';
var FeaturedBlogPost = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FeaturedBlogPost, _React$PureComponent);
  var _super = _createSuper(FeaturedBlogPost);
  function FeaturedBlogPost() {
    _classCallCheck(this, FeaturedBlogPost);
    return _super.apply(this, arguments);
  }
  _createClass(FeaturedBlogPost, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        heroImage = _this$props.heroImage,
        summary = _this$props.summary,
        publishedAt = _this$props.publishedAt,
        title = _this$props.title,
        slug = _this$props.slug;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
        as: "h2"
      }, "Featured Post"), /*#__PURE__*/React.createElement(Link, {
        to: "/".concat(slug, "/")
      }, /*#__PURE__*/React.createElement(Item.Group, null, /*#__PURE__*/React.createElement(Item, {
        className: "featured-blog-post"
      }, /*#__PURE__*/React.createElement(Image, {
        src: heroImage
      }), /*#__PURE__*/React.createElement(Item.Content, null, /*#__PURE__*/React.createElement(Item.Header, null, title), ObjectUtils.isRenderable(publishedAt) && /*#__PURE__*/React.createElement(Item.Meta, null, format(parseISO(publishedAt), 'PPP')), /*#__PURE__*/React.createElement(Item.Description, null, summary))))));
    }
  }]);
  return FeaturedBlogPost;
}(React.PureComponent);
export { FeaturedBlogPost as default };
FeaturedBlogPost.defaultProps = {
  heroImage: null,
  publishedAt: null
};